import React from 'react';
import { DateRangePicker, type DateRangePickerProps } from '@prerender/design-system/DateRangePicker';

import { DISPLAY_LOCALE } from '~library/dates';

import { DATE_RANGE_PRESETS } from './dateRangePresets';
import { type DateRangePlanGating, useDateRangePlanGating } from './useDateRangePlanGating';

type PlanGatedDateRangePickerProps = Omit<DateRangePickerProps, keyof DateRangePlanGating | 'presets' | 'dateLocale'>;

function PlanGatedDateRangePicker(props: PlanGatedDateRangePickerProps) {
  const planGating = useDateRangePlanGating();

  return <DateRangePicker {...props} dateLocale={DISPLAY_LOCALE} presets={DATE_RANGE_PRESETS} {...planGating} />;
}

export default PlanGatedDateRangePicker;
